import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { theme } from "../components/theme";
import { useCart } from "../context/CartContext";

export default function ProductPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedVariant, setSelectedVariant] = useState("14");
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);

  useEffect(() => {
    getDoc(doc(db, "products", id)).then((snap) => {
      if (snap.exists()) setProduct({ id: snap.id, ...snap.data() });
      setLoading(false);
    });
  }, [id]);

  if (loading)
    return (
      <Loading>
        <div className="spinner" />
      </Loading>
    );
  if (!product)
    return (
      <Loading>
        <p>Produkti nuk u gjet.</p>
      </Loading>
    );

  const price = selectedVariant === "14" ? product.price14 : product.price21;

  const handleAddToCart = () => {
    addToCart({
      id: product.id,
      name: product.name,
      variant: selectedVariant,
      price,
      qty,
      imageUrl: product.imageUrl,
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <Page>
      <BackBtn onClick={() => navigate(-1)}>← Kthehu</BackBtn>
      <Grid>
        <ImageCol>
          <ProductImg src={product.imageUrl} alt={product.name} />
          {product.badge && <BadgeTag>{product.badge}</BadgeTag>}
        </ImageCol>

        <InfoCol>
          <Eyebrow>OrgaLife — Detox Shot</Eyebrow>
          <ProductName>{product.name}</ProductName>
          <ShortDesc>{product.shortDesc}</ShortDesc>

          <Divider />

          <Label>Zgjidh paketën</Label>
          <VariantRow>
            {["14", "21"].map((v) => (
              <VariantBtn
                key={v}
                active={selectedVariant === v}
                onClick={() => setSelectedVariant(v)}
              >
                <VNum>{v}</VNum>
                <VLabel>shotsa per {v} dite</VLabel>
                <VPrice>
                  €
                  {(v === "14" ? product.price14 : product.price21)?.toFixed(2)}
                </VPrice>
              </VariantBtn>
            ))}
          </VariantRow>

          <Label style={{ marginTop: "1.5rem" }}>Sasia</Label>
          <QtyRow>
            <QtyBtn onClick={() => setQty(Math.max(1, qty - 1))}>−</QtyBtn>
            <QtyNum>{qty}</QtyNum>
            <QtyBtn onClick={() => setQty(qty + 1)}>+</QtyBtn>
          </QtyRow>

          <PriceTotal>
            Totali: <span>€{(price * qty).toFixed(2)}</span>
          </PriceTotal>

          <AddBtn onClick={handleAddToCart} added={added}>
            {added ? "✓ U shtua në shportë!" : "Shto në Shportë"}
          </AddBtn>

          {product.description && (
            <>
              <Divider />
              <Label>Përshkrimi</Label>
              <FullDesc>{product.description}</FullDesc>
            </>
          )}

          <Tags>
            <Tag>🌿 Organik</Tag>
            <Tag>🔥 Raw</Tag>
            <Tag>✦ Vegan</Tag>
            <Tag>❄️ Cold-pressed</Tag>
          </Tags>
        </InfoCol>
      </Grid>
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  background: ${theme.colors.bg};
  padding: 7rem 5vw 5rem;
`;
const BackBtn = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.textSecondary};
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  font-family: ${theme.fonts.mono};
  cursor: pointer;
  margin-bottom: 2.5rem;
  padding: 0;
  &:hover {
    color: ${theme.colors.textPrimary};
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  max-width: 1100px;
  margin: 0 auto;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;
const ImageCol = styled.div`
  position: relative;
`;
const ProductImg = styled.img`
  width: 100%;
  /* aspect-ratio: 1; */
  object-fit: contain;
  border-radius: ${theme.radius.lg};
  border: 1px solid ${theme.colors.borderSubtle};
`;
const BadgeTag = styled.span`
  position: absolute;
  top: 16px;
  left: 16px;
  background: #89d146;
  color: white;
  font-size: 0.65rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 999px;
  font-family: ${theme.fonts.mono};
`;
const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
`;
const Eyebrow = styled.p`
  font-family: ${theme.fonts.mono};
  font-size: 0.65rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};
  margin-bottom: 0.75rem;
`;
const ProductName = styled.h1`
  font-family: "Playfair Display", serif;
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  color: ${theme.colors.textPrimary};
  font-weight: 500;
  font-style: italic;
  margin: 0 0 0.75rem;
`;
const ShortDesc = styled.p`
  font-size: 0.9rem;
  color: ${theme.colors.textSecondary};
  line-height: 1.75;
  margin-bottom: 0;
`;
const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${theme.colors.borderSubtle};
  margin: 1.5rem 0;
`;
const Label = styled.p`
  font-family: ${theme.fonts.mono};
  font-size: 0.65rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};
  margin-bottom: 0.75rem;
`;
const VariantRow = styled.div`
  display: flex;
  gap: 1rem;
`;
const VariantBtn = styled.button`
  flex: 1;
  padding: 1rem;
  border-radius: ${theme.radius.md};
  border: 2px solid
    ${({ active }) => (active ? "#89d146" : theme.colors.borderSubtle)};
  background: ${({ active }) =>
    active ? "rgb(71, 90, 52)" : theme.colors.bgDeep};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  &:hover {
    border-color: #89d146;
  }
`;
const VNum = styled.span`
  font-family: "Playfair Display", serif;
  font-size: 1.6rem;
  font-style: italic;
  color: ${theme.colors.textPrimary};
`;
const VLabel = styled.span`
  font-size: 0.65rem;
  color: ${theme.colors.textMuted};
  font-family: ${theme.fonts.mono};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;
const VPrice = styled.span`
  font-family: ${theme.fonts.mono};
  font-size: 0.85rem;
  color: #89d146;
  margin-top: 4px;
`;
const QtyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const QtyBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${theme.colors.border};
  background: ${theme.colors.bgSurface};
  color: ${theme.colors.textSecondary};
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  &:hover {
    background: #89d146;
    border-color: #89d146;
    color: white;
  }
`;
const QtyNum = styled.span`
  font-size: 1.2rem;
  color: ${theme.colors.textPrimary};
  min-width: 30px;
  text-align: center;
`;
const PriceTotal = styled.p`
  font-family: ${theme.fonts.mono};
  font-size: 0.85rem;
  color: ${theme.colors.textMuted};
  margin: 1.25rem 0;
  span {
    color: #89d146;
    font-size: 1.1rem;
  }
`;
const AddBtn = styled.button`
  width: 100%;
  padding: 1.1rem;
  border-radius: 999px;
  border: none;
  background: ${({ added }) => (added ? "#5aad2e" : "#89d146")};
  color: white;
  font-size: 1rem;
  font-weight: 600;
  font-family: ${theme.fonts.body};
  letter-spacing: 0.06em;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: #7bc23e;
    transform: translateY(-2px);
  }
`;
const FullDesc = styled.p`
  font-size: 0.88rem;
  color: ${theme.colors.textSecondary};
  line-height: 1.85;
`;
const Tags = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 1.5rem;
`;
const Tag = styled.span`
  font-family: ${theme.fonts.mono};
  font-size: 0.65rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${theme.colors.textSecondary};
  background: ${theme.colors.bgSurface};
  border: 1px solid ${theme.colors.borderSubtle};
  padding: 5px 12px;
  border-radius: 999px;
`;
const Loading = styled.div`
  min-height: 100vh;
  background: ${theme.colors.bg};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.textSecondary};
  .spinner {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid ${theme.colors.borderSubtle};
    border-top-color: #89d146;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
